import Parse from "parse";
import {
  getClassName,
  setLimit,
  setACL,
  addImageIfExists,
  filterKeys
} from "./ParseConfiguration";
import { Member } from "../Models/Member.ts";
import { v4 as uuid } from 'uuid';
import { handleError } from "./ErrorHandler.ts";


const USER_TABLE = getClassName("_User")


export async function getUsers(): Promise<Member[]> {
  try {
    const query = new Parse.Query(USER_TABLE)
    query.descending("createdAt")
    const count = await query.count()
    setLimit(query, count)
    const result = await query.find()

    return result.map((parseObject) =>
      Member.convertFromParseObject(parseObject)
    )
  } catch (error) {
    handleError(error)
    throw error
  }
}

export async function getUserById(objectId) {
  try {
    const query = new Parse.Query(USER_TABLE)
    const parseObject = await query.get(objectId)
    const result = Member.convertFromParseObject(parseObject)
    return result

  } catch (error) {
    handleError(error)
    throw error
  }
}

export function getUserByFullName(fullName) {
  const [firstName, lastName] = fullName.split(" ");
  return new Parse.Query(USER_TABLE)
    .matches("name", firstName, "i")
    .matches("surname", lastName, "i")
    .find();
}

export async function addOrUpdateUser(newUser, avatar) {
  try {
    const Member = USER_TABLE
    const memberObject = new Member()
    Object.entries(newUser)
      .filter((key) => !filterKeys.includes(key[0]))
      .forEach((key) => {
        if (key[0] === "newMembersOrder") {
          const order = newUser["isNew"] ? Number(newUser[key[0]]) : null
          memberObject.set(key[0], order)
        } else {
          memberObject.set(key[0], newUser[key[0]])
        }
        memberObject.set(key[0], key[1])
      })
    memberObject.set("visibleEmail", newUser.email)
    addDefaultFieldsIfNew(memberObject, newUser.objectId, newUser.password)
    await addImageIfExists(memberObject, avatar, "avatar")
    await memberObject.save()

  } catch (error) {
    handleError(error)
    throw error
  }
}

export async function deleteUser(objectId) {
  try {
    const query = new Parse.Query(USER_TABLE)
    query.get(objectId)
    const result = await query.find()
    if (result.length >= 1) {
      await result[0].destroy()
    }

  } catch (error) {
    handleError(error)
    throw error
  }
}

export async function updateUserIsNewValue(objectId, eventsOrder, isNew) {
  try {
    const query = new Parse.Query(USER_TABLE)
    query.get(objectId)
    const result = await query.find()
    if (result.length >= 1) {
      result[0].set("isNew", isNew)
      const newEventsOrder = isNew ? eventsOrder : null
      result[0].set("newMembersOrder", newEventsOrder)
      result[0].save()
    }

  } catch (error) {
    handleError(error)
    throw error
  }
}

export async function updateUserHidingValue(objectId, isHiding) {
  try {
    const query = new Parse.Query(USER_TABLE)
    query.get(objectId)
    const result = await query.find()
    if (result.length >= 1) {
      result[0].set("hidden", isHiding)
      result[0].save()
    }

  } catch (error) {
    handleError(error)
    throw error
  }
}

export async function changePasswordForMember(objectId, password) {
  try {
    const query = new Parse.Query(USER_TABLE)
    query.get(objectId)
    const result = await query.find()
    if (result.length >= 1) {
      result[0].set("password", password)
      result[0].save()
    }

  } catch (error) {
    handleError(error)
    throw error
  }
}

function addDefaultFieldsIfNew(parseObject, objectId, password) {
  if (objectId === undefined) {
    parseObject.set("username", uuid().replace(/-/g, ""));
    parseObject.set("password", password);
    parseObject.set("interests", []);
    parseObject.set("expertise", []);
    setACL(parseObject);
  }
}
